window.Products.HomeDecor.VeganLeatherPlacemat = function () {}
window.Products.HomeDecor.VeganLeatherPlacemat.inherits(window.Products.HomeDecor.HomeDecor)